import { IconX } from "@tabler/icons-react";
import { useState } from "react";

import { updateExpenseBankStatementId } from "../../../Api/Expense";

interface ExpenseModelProps {
  isOpen: boolean;
  onClose: () => void;
  transactionAmount: number;
  bankstatementId: string;
  Expenses: any[];
  fetchExpensesData: (id: string, amount: number) => Promise<void>;
  fetchAssignedExpenseData: (id: string) => Promise<void>; 
   onSuccess?: () => void;
}

const ExpenseModel = ({
  isOpen,
  onClose,
  transactionAmount,
  bankstatementId,
  Expenses,
  fetchExpensesData,
  fetchAssignedExpenseData,
  onSuccess,
}: ExpenseModelProps) => {
  const [selectedExpenseIds, setSelectedExpenseIds] = useState<string[]>([]);

  const handleCheckboxChange = (expenseId: string) => {
    setSelectedExpenseIds((prevSelected) =>
      prevSelected.includes(expenseId)
        ? prevSelected.filter((id) => id !== expenseId)
        : [...prevSelected, expenseId]
    );
  };

  const selectedExpenseAmount = Expenses.reduce((total, expense) => {
    return selectedExpenseIds.includes(expense.id)
      ? total + expense.amount
      : total;
  }, 0);

  const isSubmitEnabled = selectedExpenseAmount === transactionAmount;

  const handleSubmit = async () => {
    try {
      await updateExpenseBankStatementId(selectedExpenseIds, bankstatementId);
      await fetchExpensesData(bankstatementId, transactionAmount);
      await fetchAssignedExpenseData(bankstatementId);
    } catch (error) {
      console.error("Error updating bank statement ID:", error);
    }
  };

  return (
    <div className="p-6">
      <div>
        <div className="flex justify-between items-center border-b pb-1">
          <h1 className="text-xl font-semibold text-blue-700">
            Assign Expense
          </h1>
        </div>

        <div
          className="mt-4 overflow-auto"
          style={{
            maxHeight: "300px",
          }}
        >
          <table className="min-w-full divide-y divide-gray-200">
            <thead>
              <tr>
                <th className="px-1 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"></th>
                <th className="px-1 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Amount
                </th>
                <th className="px-1 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Type
                </th>
                <th className="px-1 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Sub-type
                </th>
                <th className="px-1 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Purpose
                </th>
                <th className="px-1 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Expense On
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {Expenses.length === 0 ? (
                <tr>
                  <td
                    colSpan={6}
                    className="px-1 py-4 text-sm text-gray-900 text-center"
                  >
                    No Expenses found.
                  </td>
                </tr>
              ) : (
                Expenses.map((expense) => {
                  return (
                    <tr key={expense.id}>
                      <td className="px-1 py-4 whitespace-nowrap text-sm text-gray-900">
                        <input
                          type="checkbox"
                          name="donation"
                          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded-sm focus:ring-blue-500"
                          checked={selectedExpenseIds.includes(expense.id)}
                          onChange={() => handleCheckboxChange(expense.id)}
                        />
                      </td>
                      <td className="px-1 py-4 whitespace-nowrap text-sm text-gray-900">
                        {expense.amount}
                      </td>
                      <td className="px-1 py-4 whitespace-nowrap text-sm text-gray-900">
                        {expense.typeName}
                      </td>
                      <td className="px-1 py-4 whitespace-nowrap text-sm text-gray-900">
                        {expense.typeValue}
                      </td>
                      <td className="px-1 py-4 whitespace-nowrap text-sm text-gray-900">
                        {expense.donationPurpose}
                      </td>

                      {/* <td className="px-1 py-4 whitespace-nowrap text-sm text-gray-900">{expense.t}</td> */}
                      <td className="px-1 py-4 whitespace-nowrap text-sm text-gray-900">
                        {new Date(expense.expenseOn).toLocaleDateString(
                          "hi-IN",
                          {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                          }
                        )}
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>

        <div className="mt-2">
          <p className="flex justify-center text-sm text-gray-700">
            Selected donation amount: {selectedExpenseAmount} /{" "}
            {transactionAmount}
          </p>
        </div>

        <div className="flex justify-start mt-4">
          <button
            className={`bg-blue-500 text-white px-3 py-2 rounded-md mr-2 text-sm ${isSubmitEnabled
                ? "hover:bg-blue-600"
                : "opacity-50 cursor-not-allowed"
            }`}
            disabled={!isSubmitEnabled}
            onClick={() => {
              handleSubmit();
              onClose();
            }}
          >
            Submit
          </button>
          <button
            onClick={onClose}
            className="bg-blue-500 text-white px-3 py-2 rounded-md hover:bg-blue-600 mr-2 text-sm"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExpenseModel;
